import(/* webpackMode: "eager" */ "/app/packages/stadium-shops/src/app/global-error.js");
